import { Z_INDEX_DRAWER as f } from "./index.es174.js";
import a from "./index.es790.js";
const p = (t) => {
  switch (t) {
    case "right":
      return a.drawerRight;
    case "left":
      return a.drawerLeft;
    case "top":
      return a.drawerTop;
    case "bottom":
      return a.drawerBottom;
    default:
      return "";
  }
}, u = (t) => {
  switch (t) {
    case "right":
      return "translateX(100%)";
    case "left":
      return "translateX(-100%)";
    case "top":
      return "translateY(-100%)";
    case "bottom":
      return "translateY(100%)";
    default:
      return "";
  }
}, m = (t) => typeof t == "number" ? t : typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : parseFloat(t), b = (t, s, r, l = !1) => {
  const e = "8px", o = "var(--plac-lines-default)", d = {
    background: "var(--plac-primary-white)",
    boxShadow: "0 10px 15px -3px var(--plac-sticky-shadow)",
    display: "flex",
    flexDirection: "column",
    transition: "transform 300ms ease-out",
    position: l ? "absolute" : "fixed",
    zIndex: f
  }, n = {
    right: {
      right: 0,
      top: 0,
      height: r,
      width: s,
      borderLeft: `1px solid ${o}`
    },
    left: {
      left: 0,
      top: 0,
      height: r,
      width: s,
      borderRight: `1px solid ${o}`
    },
    top: {
      top: 0,
      left: 0,
      width: "100%",
      height: r,
      borderBottom: `1px solid ${o}`,
      borderBottomLeftRadius: e,
      borderBottomRightRadius: e
    },
    bottom: {
      bottom: 0,
      left: 0,
      width: "100%",
      height: r,
      borderTop: `1px solid ${o}`,
      borderTopLeftRadius: e,
      borderTopRightRadius: e
    }
  };
  return (t === "left" || t === "right") && l && r === "100%" && (n[t].height = "100%"), {
    ...d,
    ...n[t]
  };
};
export {
  b as getDrawerStyle,
  u as getOffscreenTransform,
  p as getPositionClass,
  m as normalizeSnapPoint
};
//# sourceMappingURL=index.es789.js.map
